export const CALL_STATUS_NAMES = {
    HANG_UP: 'Hang up'
}